import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import Icon from "../../common/icon/icon.component"
import { DATA_3DSECURE_STATUS } from "../../state/helpers/Payment"


type OwnProps = {
    className?: string
    status: string
}

const Status3DSecureBadge = (props: OwnProps) => {

    const getStatusDetails = (status: string): { className: string, icon: string, label: JSX.Element } => {
        switch (status) {
        case DATA_3DSECURE_STATUS.FAILED: return {
            className: "badge-danger",
            icon: "times",
            label: <FormattedMessage
                id="payment.status_3ds.failed"
                defaultMessage="Failed"
            />,
        }
        case DATA_3DSECURE_STATUS.SUCCEEDED: return {
            className: "badge-success",
            icon: "check",
            label: <FormattedMessage
                id="payment.status_3ds.succeeded"
                defaultMessage="Succeeded"
            />,
        }
        default: return {
            className: "",
            icon: "",
            label: <></>,
        }
        }
    }

    const details = getStatusDetails(props.status)

    return <span className={props.className + " badge badge-pill " + details.className}>
        <Icon className={"mr-1"} value={details.icon} />
        {details.label}
    </span>

}

export default injectIntl(Status3DSecureBadge)


// WEBPACK FOOTER //
// ./src/payment-processing/configuration-3ds/Status3DSecureBadge.tsx